<script lang="ts">
  export let image: string | undefined;
  export let imageAlt: string | undefined;
  export let numberOfInjectedComponents: number = 0;

  const bodySectionClass: string = numberOfInjectedComponents > 1 ? 'h-50' : 'h-60';
</script>

<div class="position-relative {bodySectionClass}">
  {#if image && numberOfInjectedComponents === 1}
    <div class="body-img">
      <img class="small-img w-100 pb-2 img-fluid" src={image} alt={imageAlt} />
    </div>
  {:else if !image}
    <div class="body-slot mt-2">
      <slot />
    </div>
  {/if}
</div>

{#if image && numberOfInjectedComponents === 0}
  <img class="large-img w-100 img-fluid pt-4 pb-2" src={image} alt={imageAlt} />
{/if}

<style>
  .body-img {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .large-img,
  .small-img {
    object-fit: contain;
  }

  .large-img {
    height: 240px;
  }

  .small-img {
    height: 210px;
  }

  .h-60 {
    height: 60%;
  }

  @media (min-width: 991px) and (max-width: 1200px) {
    .small-img {
      height: 175px;
    }
  }
</style>
